module.exports = __webpack_public_path__ + "nKKZ-Go6G5tXcraVGwA.543446b96dc21c216412.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/src/css/nKKZ-Go6G5tXcraVGwA.woff2
// module id = ../../../../../src/css/nKKZ-Go6G5tXcraVGwA.woff2
// module chunks = styles